import { useEffect, useState } from 'react';

const KEY = 'findish_dark';

function readDark() {
  try { return localStorage.getItem(KEY) === 'true'; }
  catch { return false; }
}

export default function useDarkMode() {
  const [darkMode, setDarkMode] = useState(readDark);

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === KEY) setDarkMode(readDark());
    };
    const onCustom = () => setDarkMode(readDark());
    window.addEventListener('storage', onStorage);
    window.addEventListener('findish-dark-changed', onCustom);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('findish-dark-changed', onCustom);
    };
  }, []);

  const toggle = () => {
    const next = !readDark();
    try { localStorage.setItem(KEY, String(next)); } catch {}
    setDarkMode(next);
    window.dispatchEvent(new Event('findish-dark-changed'));
  };

  return [darkMode, toggle];
}
